var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WorkspaceMfaRequirement } from '@lucidlink/dto/validation';
import { Box, Link, MessageBox, Trans } from '@lucidlink/uicore';
import { useAuthProvider } from '#context';
import { useGetWorkspaceLoginStatus, useWorkspaceById } from '#query-hooks';
export const TwoFactorAuthenticationLayout = ({ children, workspaceId, }) => {
    _react_refresh_temp_2();
    const { currentUser } = useAuthProvider();
    const { query: { data }, } = useWorkspaceById(workspaceId);
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    // there is a case where the workspace data has not updated that the mfaRequirement
    // is not onNextLogin but required as the loginStatus returns
    const isMfaRequiredOnNextLogin = data?.mfaRequirement === WorkspaceMfaRequirement.ON_NEXT_LOGIN;
    const hasNotCompletedMfa = !currentUser?.hasCompletedMfa;
    const isLoginStatusNotRequired = workspaceLoginStatus?.mfaRequirement !==
        WorkspaceMfaRequirement.REQUIRED;
    if (isMfaRequiredOnNextLogin &&
        hasNotCompletedMfa &&
        isLoginStatusNotRequired) {
        return (_jsxs(Box, { gap: "s", isFullHeight: true, isFullWidth: true, orientation: "vertical", children: [_jsxs(MessageBox, { "data-testid": "two-factor-authentication-required-on-next-login", type: "informative", children: [_jsx(Trans, { children: "This workspace will require 2FA upon your next login.\u00A0" }), _jsx(Link, { "data-testid": "two-factor-authentication", inheritFontStyles: true, to: "/account", children: _jsx(Trans, { children: "Set up 2FA" }) })] }), _jsx(Box, { grow: 1, scrollableY: true, children: children })] }));
    }
    return children;
};
_react_refresh_temp_1 = TwoFactorAuthenticationLayout;
$RefreshReg$(_react_refresh_temp_1, "TwoFactorAuthenticationLayout");
_react_refresh_temp_2(TwoFactorAuthenticationLayout, "spH0dpoG7hpEBCn7jO0H0TDvfWs=", false, () => [useAuthProvider, useWorkspaceById, useGetWorkspaceLoginStatus]);
